import React from "react";
import { Paragraph } from "components/Typography";
import { Link } from "@mui/material";

// eslint-disable-next-line
export default {
  title: "About",
  data: (
    <>
      <Paragraph variant="body2">
        Andrés Guadarrama (b. 1991) is a Mexico City-based composer, performer
        and sound artist. Currently, his work revolves around topics such as the
        force and agency of things, the ecology of the performatic space, and
        the study and incorporation of ancestral knowledge. Through his work, he
        designs physical networks of interaction and interdependence between
        people, objects, spaces and natural forces.
      </Paragraph>
      <Paragraph variant="body2">
        His music has been performed through the Americas, Europe and Asia by
        musicians such as{" "}
        <Link variant="body2" href="https://www.yarnwire.org/">
          Yarn/Wire
        </Link>
        , Joseph Houston,{" "}
        <Link variant="body2" href="http://umsnjip.ch/">
          UMS ’n JIP
        </Link>
        ,{" "}
        <Link variant="body2" href="http://www.eva-zoellner.de/">
          Eva Zöllner
        </Link>
        ,{" "}
        <Link variant="body2" href="https://www.tallersonoro.com/">
          Taller Sonoro
        </Link>
        , Boglárka Nagy, Irvine Arditti,
        <Link variant="body2" href="http://www.tambuco.org/">
          Tambuco
        </Link>
        , among others; and programmed on festivals like Donaueschinger
        Musiktage, NUNC! 4, The 21st Century Guitar Conference, Forum Wallis,
        Jornadas de Música Contemporánea CCMC, Foro Internacional de Música
        Nueva Manuel Enríquez.
      </Paragraph>
      <Paragraph variant="body2">
        He has received awards such as the FONCA Young Creators fellowship;
        commissions from the{" "}
        <Link variant="body2" href="https://jackquartet.com/">
          JACK Quartet
        </Link>
        ,{" "}
        <Link variant="body2" href="https://robertoalonsotrillo.com/">
          Roberto Alonso Trillo
        </Link>{" "}
        and{" "}
        <Link variant="body2" href="https://www.tetractysnewmusic.com/">
          Tetraktys New Music
        </Link>
        ; and representing Mexico in the 63rd UNESCO International Composers
        Tribune in Wrocław, Poland.
      </Paragraph>
      <Paragraph variant="body2">
        As a performer, Andrés is a member of the new music ensembles Attica!
        and XIN.
      </Paragraph>
      <Paragraph variant="body2">
        Andrés holds a degree in Composition and Music Theory from the Centro de
        Investigación y Estudios de la Música (CIEM). He later studied under
        composers Germán Romero and Samuel Cedillo.
      </Paragraph>
    </>
  ),
};
